import { Component } from '@angular/core';
import { ADBInfo, DBPanelInfo } from '../../../../../models/datamodel/adbinfo.model';
import { BaseDataSourcePanel } from '../../../../../settings/datamodel/datasource/datasourcepanels/basedatasource.panel';

@Component({
    selector: 'bigquery-panel',
    templateUrl: './bigquery.panel.html'
})
export class BigQueryPanel extends BaseDataSourcePanel {

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: BigQueryPanel,
            DBInfoType: BigQueryDBInfo
        };
    }

    constructor() {
        super();
        this.DBInfoType = BigQueryDBInfo;
    }   
}

export class BigQueryDBInfo extends ADBInfo {
    ProjectId: string;
    JsonString: string;
    getTypeName(): string {
        return 'evidanza.Database.BigQuery.BigQueryDBInfo';
    }
}
